import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  size?: "lg" | "md";
  pulse?: boolean;
  className?: string;
};
export function CtaButton({
  label,
  id,
  size = "lg",
  pulse = false,
  className = ""
}: CtaButtonProps) {
  const sizing = size === "lg" ? "min-h-[64px] px-6 py-4 text-[17px] sm:text-lg" : "min-h-[56px] px-5 py-3.5 text-base";
  return <a id={id} href={CHECKOUT_URL} className={`group relative flex w-full max-w-xl mx-auto items-center justify-center gap-3 rounded-2xl bg-cta text-white font-extrabold uppercase tracking-wide leading-tight text-center shadow-[0_10px_30px_-8px_rgba(22,163,74,0.6)] border-b-4 border-cta-dark transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 ${pulse ? "animate-cta-pulse" : ""} ${sizing} ${className}`} data-id="element-29" data-mp="llh1p90gh4rm">
      <span className="text-balance" data-id="element-30" data-mp="35yhay8mpzg7u">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="39yrgjk6lo4m6" />
    </a>;
}